module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-01-97a89d1b347c648efddb3762e4c6a41c.png";